import { Link } from "react-router-dom";
import Reveal from "./Reveal";
import { EXPERIENCES } from "../data/site";

export default function ExperiencesSection() {
  return (
    <section
      id="experiences"
      data-testid="experiences-section"
      className="py-28 md:py-40 bg-[color:var(--bs-ink)] text-white overflow-hidden"
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 items-end">
          <Reveal className="md:col-span-8">
            <div className="overline text-white/50">Expériences</div>
            <h2 className="mt-6 font-display text-5xl md:text-7xl lg:text-8xl font-light tracking-tight leading-[0.95]">
              Prenez de <br />
              <span className="italic text-[color:var(--bs-gold)]">la hauteur.</span>
            </h2>
          </Reveal>
          <Reveal className="md:col-span-4" delay={0.1}>
            <p className="text-white/60 leading-relaxed font-light">
              De la découverte à l'événementiel, chaque mission est composée
              avec soin. Tarifs publics ou devis dédié.
            </p>
          </Reveal>
        </div>

        <div className="mt-20 md:mt-28 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {EXPERIENCES.map((e, i) => (
            <Reveal key={e.id} delay={0.04 * i}>
              <article
                data-testid={`experience-${e.id}`}
                className="group relative border-t border-white/15 pt-8 h-full flex flex-col"
              >
                <div className="flex items-baseline justify-between">
                  <span className="font-display text-[color:var(--bs-gold)] text-6xl md:text-7xl leading-none font-light">
                    {e.number}
                  </span>
                  {e.quote && (
                    <span className="overline text-white/50 border border-white/20 px-3 py-1">
                      Sur devis
                    </span>
                  )}
                </div>
                <h3 className="mt-8 font-display text-3xl md:text-4xl font-light">
                  {e.title}
                </h3>
                <p className="mt-4 text-white/60 font-light leading-relaxed">
                  {e.lead}
                </p>
                <ul className="mt-6 space-y-2">
                  {e.included.map((it) => (
                    <li
                      key={it}
                      className="text-sm text-white/70 flex items-start gap-3"
                    >
                      <span className="text-[color:var(--bs-gold)] mt-1.5">—</span>
                      {it}
                    </li>
                  ))}
                </ul>
                <Link
                  to="/reservation"
                  data-testid={`experience-cta-${e.id}`}
                  className="mt-auto pt-10 overline link-underline text-white"
                >
                  {e.quote ? "Demander un devis" : "Réserver ce vol"} →
                </Link>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
